import { nanoid } from "nanoid";
import { Catch } from "./catch.model";
import { Coordinate } from "./coordinate.model";
import { LookupItem } from "./lookup-item.model";
import { SetDetailTrawlComponent } from "../set-detail-trawl/set-detail-trawl.component";
import { formatDate } from "@angular/common";

export class TrawlSet {


  //Unique identifier for this fishing event
  fishingEventID: string = '';

  comments: string = '';

  netType: LookupItem = new LookupItem('');

  codendCapacity!: number;

  targetSpecies: LookupItem = new LookupItem('');

  startDate!: Date; 

  startLat: Coordinate = new Coordinate;

  startLon: Coordinate = new Coordinate;

  startLatManualEntry!: boolean;

  startLonManualEntry!: boolean;

  endDate!: Date;

  endLat: Coordinate = new Coordinate;

  endLon: Coordinate = new Coordinate;

  endLatManualEntry!: boolean;

  endLonManualEntry!: boolean;

  averageDepth!: number;

  lostNet: boolean = false;

  catchItems: Catch[] = []; // can probably reuse same catch model?


  /**
   * Called to update the {@link SetDetailTrawlComponent.fishingEvent}
   * @param form Updated fishing event data
   */
  update(form: any) {
    this.startDate = form.startDate;
    this.endDate = form.endDate;
    this.averageDepth = form.averageDepth;
    this.startLat = form.startLat;
    this.startLon = form.startLon;
    this.endLat = form.endLat;
    this.endLon = form.endLon;
    this.comments = form.comments;
    this.netType = form.netType;
    this.codendCapacity = form.codendCapacity;
    this.targetSpecies = form.targetSpecies;
    this.lostNet = form.lostNet;
  }


  static transformAnonymous(anon: any) {
    let fe = new TrawlSet();
    fe.fishingEventID = anon.fishingEventID ?? 'set-' + nanoid();
    if (fe.fishingEventID == '') fe.fishingEventID = 'set-' + nanoid();
    fe.comments = anon.comments;
    fe.netType = LookupItem.transformAnonymous(anon.netType);
    fe.codendCapacity = anon.codendCapacity;
    fe.targetSpecies = LookupItem.transformAnonymous(anon.targetSpecies);
    fe.startDate = anon.startDate;
    fe.startLat = Coordinate.transformAnon(anon.startLat);
    fe.startLon = Coordinate.transformAnon(anon.startLon);
    fe.startLatManualEntry = anon.startLatManualEntry;
    fe.startLonManualEntry = anon.startLonManualEntry;
    fe.endDate = anon.endDate;
    fe.endLat = Coordinate.transformAnon(anon.endLat);
    fe.endLon = Coordinate.transformAnon(anon.endLon);
    fe.endLatManualEntry = anon.endLatManualEntry;
    fe.endLonManualEntry = anon.endLonManualEntry;
    fe.averageDepth = anon.averageDepth;
    fe.lostNet = anon.lostNet;
    fe.catchItems = Catch.transformAnonymous(anon.catchItems);
    return fe;
  }

   toString() {
    return this.startDate ? formatDate(this.startDate, 'MM/dd/yyyy', 'en-US')  : 'No Haul start';
  }

}
